export default {
  model: {
    'role': 'Rôles d\'administrateur',
    'activeStorage/attachment': 'Attachment',
    'application': 'Application',
    'adminUsersRole': 'Comptes administrateur',
    'adminUser': 'utilisateur administrateur',
    'banner': 'Bannière',
    'profile': 'profil',
    'miapay/walletHolder': 'Wallet holder',
    'storeOwner': 'Propriétaire du magasin',
    'event': 'Remboursement',
    'merchant': 'Magasin',
    'agent': 'Compte de paiement',
    'user': 'utilisatrice',
    'walk/account': 'Account',
    'activeStorage/blob': 'Goutte',
    'actsAsTaggableOn/tag': 'Balises d\'événement',
    'page': 'FAQ',
    'presetPage': 'FAQ',
    'staticPage': 'FAQ',
    'customPage': 'Page personnalisée',
    'hotWord': 'Mot chaud',
    'miapay/fundingSource': 'Funding source',
    'withdrawalApplication': 'Retraits',
    'feedback': 'Retour',
    'miapay/transactionMetaDatum': 'Transaction meta datum',
    'plutus/entry': 'Entry',
    'brand': 'Marques',
    'redPacket': 'Saisir SP',
    'customListItem': 'Articles',
    'pushNotificationHistory': 'Historique des notifications push',
    'ticketEvent': 'Événement',
    'ticketKind': 'Billet',
    'ticketOrder': 'Détails des billets vendus',
    'ticketOrderItem': 'Ticket order item',
    'ticket': 'Participantes',
    'resetPasswordApplication': 'Réinitialiser le code PIN',
    'ticketRedeemBatch': 'Synchroniser l\'historique des échanges',
    'ticketRedeemItem': 'Ticket redeem item',
    'customList': 'Espace publicitaire et vidéo',
    'walk/hebaRewardRuleItem': 'HEBA règle de récompense',
    'walk/hebaParticipationRecord': 'HEBA participants',
    'walk/stepRecord': 'Enregistrements d\'étapes',
    'userRequest': 'Électricité & Temps d\'antenne',
    'walk/club': 'LeCLuB clubs',
    'walk/prize': 'LeCLuB prix',
    'walk/challenge': 'LeCLuB défis',
    'walk/challengeParticipationRecord': 'Les participants au défi',
    'link': 'Link',
    'operationRecord': 'Registre des opérations',
    'setting': 'Réglage',
  },
  'role': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    kind: `Type`,
    kinds: {
      super: 'Super',
      application: 'Application',
      custom: 'Custom',
    },
    customPermissions: `Autorisations personnalisées`,
  },
  'activeStorage/attachment': {
    id: `ID`,
    createdAt: `Créé à`,
    signedId: `Signed`,
    contentType: `Content type`,
    filename: `Filename`,
    byteSize: `Byte size`,
    url: `Url`,
  },
  'application': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    desc: `Desc`,
    shareDesc: `Partager la description`,
    shareTitle: `Partager le titre`,
    wechatApplicationId: `Wechat application`,
    applicationAdminUsersRoleId: `Application admin users role`,
    shareImage: `Partager l'image`,
    logo: `Logo`,
    creator: `Créateur`,
    posterImage: `Image d'affiche`,
  },
  'adminUsersRole': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    roleId: `Rôle`,
    adminUserId: `Admin user`,
    applicationId: `ID d'application`,
    role: `Rôle`,
    application: `Application`,
    adminUser: `utilisateur administrateur`,
    preferences: `Préférences`,
    adminUserAttributes: `Admin user attributes`,
  },
  'adminUser': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    email: `E-mail`,
    name: `Nom d'utilisateur`,
    adminUsersRolesAttributes: `Admin users roles attributes`,
  },
  'banner': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    target: `Vibler`,
    position: `Position`,
    pagePosition: `Emplacement de la page`,
    pagePositions: {
      event: 'Événement',
    },
    kind: `Type`,
    kinds: {
      web_link: 'Lien Web',
      image: 'Image',
      mp_link: 'Lien mp',
    },
    alt: `Autre`,
    image: `Image`,
  },
  'profile': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    email: `E-mail`,
    phone: `Téléphoner`,
    gender: `Le genre`,
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
    firstName: `Prénom`,
    lastName: `Nom de famille`,
    whatsapp: `Whatsapp`,
    instagram: `Instagram`,
    avatar: `Avatar`,
  },
  'miapay/walletHolder': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    phone: `Téléphoner`,
    profileAttributes: `Profile attributes`,
    number: `Numéro d\\'identification`,
    certificateFront: `Recto du certificat`,
    certificateBack: `Certificat de retour`,
    passport: `Passeport`,
    cardOwnership: `Card ownership`,
    certificateExpiredDate: `Date d'expiration du certificat`,
    lockedAt: `Suspendu à`,
    idType: `Type d\\'identification`,
    idTypes: {
      togolese_passport: 'Passeport togolais',
      id_card: 'Carte d\'identité',
      other_passport: 'Autre passeport',
    },
    verifyType: `Autre passeport`,
    verifyTypes: {
      by_agent: 'Par agent',
      by_self: 'En soi',
    },
  },
  'storeOwner': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    phone: `Téléphoner`,
    firstName: `Prénom`,
    lastName: `Nom de famille`,
    whatsapp: `Whatsapp`,
    email: `E-mail`,
    kind: `Type`,
    kinds: {
      individual: 'Individuel',
      retail: 'Détail',
      business: 'Entreprise',
    },
    source: `Source`,
    sources: {
      admin_create: 'Admin create',
      sign_up: 'Sign up',
    },
    name: `Nom`,
    agentStatus: `Agent status`,
  },
  'event': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    cashbackPercent: `Pourcentage de remboursement (%)`,
    cashbackStartDate: `Date de début du remboursement`,
    cashbackEndDate: `Date de fin du remboursement`,
    cashbackInstructionFr: `Description du remboursement(FR)`,
    cashbackInstructionEn: `Description du remboursement(EN)`,
    merchantId: `Magasin`,
    state: `État`,
    states: {
      will_start: 'Va commencer',
      actived: 'Activé',
      expired: 'Expiré',
    },
  },
  'merchant': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom du magasin`,
    phone: `Numéro de téléphone du magasin`,
    whatsapp: `Whatsapp`,
    instagram: `Instagram`,
    gozem: `Gozem`,
    location: `Emplacement`,
    latitude: `Latitude`,
    longitude: `Longitude`,
    introduction: `Introduction`,
    cashbackPercent: `Pourcentage de remboursement (%)`,
    followsCount: `Suit le décompte`,
    cashbackEndDate: `Date de fin du remboursement`,
    cashbackStartDate: `Date de début du remboursement`,
    cashbackInstructionFr: `Description du remboursement(FR)`,
    cashbackInstructionEn: `Description du remboursement(EN)`,
    storeOwnerId: `Store owner`,
    cover: `Couverture`,
    storeOwner: `Propriétaire du magasin`,
    showOnPlacesSection: `Show on places section`,
    showOnCatalog: `Afficher sur le catalogue`,
    showOnExploreSection: `Afficher sur la section Explorer`,
    position: `Position`,
    tagList: `Mots clés`,
    exploreTagList: `Explore tag list`,
    logo: `Logo`,
    images: `Images`,
    collectQrCodeUrl: `Collect qr code url`,
  },
  'agent': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    phone: `Téléphoner`,
    lockedAt: `Suspendu à`,
    status: `Statut`,
    statuses: {
      pending: 'En attente',
      approved: 'Approuvé',
      rejected: 'Rejeté',
      actived: 'Actif',
    },
    name: `Nom`,
    refCode: `Code de réf`,
    storeOwnerId: `Store owner`,
    storeOwner: `Propriétaire du magasin`,
    merchantId: `Magasin`,
    merchant: `Magasin`,
    miapayWalletHolderAttributes: `Miapay wallet holder attributes`,
    canResetPassword: `Can reset password`,
    balance: `Équilibre (FCFA)`,
    cashback: `Pièces (MPC)`,
  },
  'user': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    screenName: `Nom de l'écran`,
    isBlock: `Suspendue`,
    phone: `Téléphoner`,
    name: `Nom`,
    verificationState: `État de vérification`,
    verificationStates: {
      init: 'Non vérifié',
      pending: 'En attente',
      approved: 'Vérifié',
      rejected: 'Rejeté',
    },
    verifier: `Vérificateur`,
    verifyAt: `Vérifié à`,
    number: `Numéro d'identification`,
    rejectReason: `Raison du rejet`,
    miapayWalletHolderAttributes: `Miapay wallet holder attributes`,
    canResetPassword: `Can reset password`,
    canUnlockRedPacketFunction: `Can unlock red packet function`,
    balance: `Équilibre (FCFA)`,
    cashback: `Pièces (MPC)`,
    walkAccount: `Walk account`,
  },
  'walk/account': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    username: `Username`,
    joinLeclubAt: `Join leclub at`,
    lockedAt: `Suspendu à`,
  },
  'activeStorage/blob': {
    id: `ID`,
    createdAt: `Créé à`,
    signedId: `Signed`,
    contentType: `Type de contenu`,
    filename: `Nom de fichier`,
    byteSize: `Byte size`,
    url: `URL`,
    tagList: `Mots clés`,
  },
  'actsAsTaggableOn/tag': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    kind: `Type`,
    kinds: {
      ticket_event: 'Balise d\'événement',
      pavillon: 'Pavillon',
      explore: 'Explorer',
    },
  },
  'page': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    slug: `Slug`,
    title: `Titre`,
    type: `Taper`,
    applicationId: `ID d'application`,
    status: `Statut`,
    statuses: {
      draft: 'Brouillon',
      published: 'Publié',
    },
    viewsCount: `Les vues comptent`,
    miniProgramPath: `Chemin du mini-programme`,
    wxacode: `Code d'applet`,
    content: `Contenu`,
  },
  'presetPage': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    title: `Titre`,
    slug: `Slug`,
    viewsCount: `Les vues comptent`,
    content: `Contenu`,
  },
  'staticPage': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    title: `Titre`,
    slug: `Slug`,
    status: `Statut`,
    statuses: {
      draft: 'Brouillon',
      published: 'Publié',
    },
    viewsCount: `Les vues comptent`,
    wxacode: `Code d'applet`,
    content: `Contenu`,
  },
  'customPage': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    title: `Titre`,
    slug: `Slug`,
    default: `Défaut`,
    miniProgramPath: `Chemin du mini-programme`,
    publishedAt: `Publié à`,
    formalCustomPageId: `Formal custom page`,
    formalCustomPage: `Formal custom page`,
    canRollbackData: `Can rollback data`,
    configs: `Configurations`,
  },
  'hotWord': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    position: `Position`,
    applicationId: `ID d'application`,
    application: `Application`,
  },
  'miapay/fundingSource': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    number: `Numéro de téléphone`,
    type: `Type`,
  },
  'withdrawalApplication': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    amountCents: `Montant (FCFA)`,
    channel: `Canaliser`,
    number: `Numéro d'identification`,
    receivableAccountType: `Receivable account type`,
    auditorId: `Auditor`,
    receivableAccountId: `Receivable account`,
    state: `État`,
    states: {
      init: 'Init',
      completed: 'Complété',
      rejected: 'Rejeté',
    },
    walletHolderId: `Wallet holder`,
    finishedAt: `Terminé à`,
    rejectReason: `Raison du rejet`,
    auditor: `Auditeur`,
  },
  'feedback': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    phone: `Téléphoner`,
    creator: `Créateur`,
    description: `La description`,
    isResolve: `Résolu`,
    solver: `Solveur`,
    images: `Images`,
  },
  'miapay/transactionMetaDatum': {
    id: `ID`,
    createdAt: `Transaction à`,
    updatedAt: `Mis à jour à`,
    number: `ID transaction`,
    amountCents: `Montant (FCFA)`,
    state: `État`,
    states: {
      init: 'Init',
      completed: 'Completed',
      failed: 'Failed',
      canceled: 'Canceled',
    },
    finishedAt: `Terminé à`,
    kind: `Type`,
    kinds: {
      topup: 'Topup',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      pay_with_qr_code: 'Pay with qr code',
      cashback: 'Pièces (MPC)',
      create_red_packet: 'Create red packet',
      receive_red_packet: 'Receive red packet',
      red_packet_expire: 'Red packet expire',
      order_ticket: 'Order ticket',
      electricity: 'Electricity',
      airtime: 'Airtime',
      join_challenge: 'Join challenge',
    },
    creditorType: `Type de créancier`,
    debitorType: `Type de débiteur`,
    cashbackAmountCents: `Pièces (MPC)`,
    remark: `Remarque`,
    data: `Data`,
    creditorNumber: `Creditor number`,
    debitorNumber: `Debitor number`,
    creditorMiapayWalletHolder: `Creditor miapay wallet holder`,
    debitorMiapayWalletHolder: `Debitor miapay wallet holder`,
  },
  'plutus/entry': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    commercialDocumentType: `Commercial document type`,
    commercialDocumentId: `Commercial document`,
    date: `Date`,
    description: `La description`,
  },
  'brand': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    logo: `Logo`,
    poster: `Affiche`,
  },
  'redPacket': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    code: `Code`,
    type: `Type`,
    totalAmount: `Total amount`,
    quantity: `Quantité`,
    state: `État`,
    states: {
      init: 'Init',
      actived: 'Activé',
      completed: 'Complété',
      expired: 'Expiré',
    },
    expiredAt: `Expiré à`,
    kind: `Type`,
    kinds: {
      cash: 'Espèces (FCFA)',
      cashback: 'Pièces (MPC)',
    },
    limitOnePersonTotalReceiveCount: `Limiter le nombre total de réceptions par personne`,
    limitOnePersonReceiveCountPerDay: `Limit one person receive count per day`,
    remainingAmount: `Remaining amount`,
    qrcode: `QR Code`,
    brandId: `Brand`,
    brand: `Marques`,
    receivedCount: `Compte reçu`,
    receivedAmount: `Montant reçu (FCFA)`,
    user: `utilisatrice`,
    customListItemAttributes: `Custom list item attributes`,
  },
  'customListItem': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    targetType: `Target type`,
    targetId: `Target`,
    position: `Position`,
    externalLink: `External link`,
    image: `Image`,
    video: `Video`,
    videoCover: `Video cover`,
    target: `Target`,
  },
  'pushNotificationHistory': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    phones: `Phones`,
    creatorId: `Creator`,
    kind: `Type`,
    kinds: {
      sms: 'Poussée SMS',
      client: 'Poussée de l\'application cliente',
      agent: 'Poussée vers l\'application marchande',
    },
    readCount: `Compte lu`,
    sentCount: `Compte envoyé`,
    allUsers: `Tous les utilisateurs/agents`,
    openRates: `Taux d'ouverture`,
    messages: `Messages`,
    creator: `Créateur`,
  },
  'ticketEvent': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    title: `Titre`,
    address1: `Adresse 1`,
    address2: `Adresse 2`,
    businessHours: `Heures d'ouverture`,
    location: `Emplacement`,
    isShow: `Est montré`,
    endAt: `Fin à`,
    startAt: `Commencer à`,
    serialCode: `Code de série`,
    tagList: `Mots clés`,
    cover: `Couverture`,
    introduction: `Introduction`,
    faq: `FAQ`,
    posters: `Affiches`,
  },
  'ticketKind': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    ticketEventId: `Événement`,
    title: `Titre`,
    capacity: `Capacité`,
    priceCents: `Prix (FCFA)`,
    description: `La description`,
    activityTimeKind: `Type de temps d'activité`,
    activityTimeKinds: {
      exact_date: 'Date exacte',
      day_of_week: 'Jour de la semaine',
    },
    startDayOfWeek: `Commencer le jour de la semaine`,
    endDayOfWeek: `Fin du jour de la semaine`,
    startDate: `Date de début`,
    endDate: `Date de fin`,
    expirationKind: `Type d'expiration`,
    expirationKinds: {
      base_on_event: 'Basé sur l\'heure de fin de l\'événement',
      custom: 'Délai d\'expiration personnalisé',
    },
    expireAt: `Expiré à`,
    ticketEvent: `Événement`,
    soldCapacity: `Quantité vendue`,
    soldAmount: `Montant total (FCFA)`,
  },
  'ticketOrder': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    number: `Numéro d'identification`,
    amountCents: `Montant (FCFA)`,
    state: `État`,
    states: {
      pending: 'Impayé',
      paid: 'Payé',
    },
    user: `utilisatrice`,
    creator: `Créateur`,
    ticketEventId: `Événement`,
    ticketEvent: `Événement`,
    paidAt: `Payé à`,
    ticketNumberStartAt: `Numéro de ticket de départ`,
    ticketOrderItems: `Articles`,
    ticketExportStatus: `Exporter le statut du qrcode`,
    ticketExportStatuses: {
      init: 'Init',
      pending: 'En attente',
      progressing: 'En cours',
      completed: 'Complété',
    },
    exportTicketsFile: `Exporter le lien qrcode`,
  },
  'ticketOrderItem': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    priceCents: `Prix (FCFA)`,
    quantity: `Quantité`,
    ticketKind: `Billet`,
    ticketOrder: `Détails des billets vendus`,
  },
  'ticket': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    serialCode: `Code de série`,
    expireAt: `Expiré à`,
    redeemAt: `Échanger à`,
    user: `utilisatrice`,
    ticketEvent: `Événement`,
    ticketKind: `Billet`,
    redeemer: `Bénéficiaire`,
    ticketOrder: `Détails des billets vendus`,
  },
  'resetPasswordApplication': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    rejectReason: `Raison du rejet`,
    idType: `Type d'identification`,
    idTypes: {
      togolese_passport: 'Passeport togolais',
      id_card: 'Carte d\'identité',
      other_passport: 'Autre passeport',
    },
    state: `État`,
    states: {
      init: 'Init',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    miapayWalletHolder: `Miapay wallet holder`,
    certificateBack: `Certificat de retour`,
    certificateFront: `Recto du certificat`,
    passport: `Passeport`,
    auditor: `Auditeur`,
  },
  'ticketRedeemBatch': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    redeemerId: `Redeemer`,
    ticketEventId: `Événement`,
    redeemer: `Bénéficiaire`,
    ticketEvent: `Événement`,
    ticketRedeemItems: `Articles`,
  },
  'ticketRedeemItem': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    errorMessage: `Message d'erreur`,
    updateStatus: `Statut de synchronisation`,
    updateStatuses: {
      init: 'Init',
      success: 'Succès',
      failed: 'Échoué',
    },
    redeemAt: `Échanger à`,
    ticket: `Participantes`,
    ticketSerialCode: `Ticket serial code`,
  },
  'customList': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    code: `Code`,
    name: `Nom`,
    kind: `Type`,
    kinds: {
      merchant_list: 'Liste des magasins',
      list_with_image: 'Liste avec image',
      video_list: 'Liste avec vidéo',
      image: 'Une image',
    },
    isActive: `Allumer`,
    customListItemsAttributes: `Custom list items attributes`,
  },
  'walk/hebaRewardRuleItem': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    cashback: `Pièces (MPC)`,
    target: `Cible (Km)`,
  },
  'walk/hebaParticipationRecord': {
    id: `ID`,
    createdAt: `Rejoint à`,
    updatedAt: `Mis à jour à`,
    month: `Mois`,
    target: `Target`,
    healthPoints: `Points de santé`,
    rewardState: `État de la récompense`,
    rewardStates: {
      init: 'Init',
      pending: 'En attente',
      received: 'Reçu',
    },
    state: `État`,
    states: {
      pending: 'En cours',
      completed: 'Complété',
      failed: 'Incomplet',
    },
    rewardCashback: `Pièces de récompense (MPC)`,
    miapayWalletHolder: `Miapay wallet holder`,
    stepByMonth: `Étapes (après avoir rejoint)`,
    kilometersDistanceByMonth: `Distance (km)`,
  },
  'walk/stepRecord': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    date: `Date`,
    step: `Pas`,
    deviceId: `ID de l'appareil`,
    isActive: `Actif`,
    miapayWalletHolder: `Miapay wallet holder`,
    errorMessage: `Message d'erreur`,
    errorMessageCode: `Error message code`,
    errorMessageCodes: {
      only_first_wallet_holder_of_the_same_device_is_active: 'Only first wallet holder of the same device is active',
      only_highest_step_on_the_same_date_is_active: 'Only highest step on the same date is active',
      walk_account_locked: 'Walk account locked',
    },
    firstWalletHolderOfTheSameDevice: `First wallet holder of the same device`,
  },
  'userRequest': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    number: `Numéro d'identification`,
    remark: `Remarque`,
    type: `Type`,
    amountCents: `Montant (FCFA)`,
    state: `État`,
    states: {
      pending: 'Pending',
      paid: 'Paid',
    },
    userId: `User`,
    user: `utilisatrice`,
  },
  'walk/club': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    name: `Nom`,
    creatorType: `Creator type`,
    creatorId: `Creator`,
    creator: `Créateur`,
    logo: `Logo`,
    introduction: `Introduction`,
    detailImage: `Image détaillée`,
  },
  'walk/prize': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    title: `Titre`,
    introduction: `Introduction`,
    covers: `Couvertures`,
    images: `Images`,
  },
  'walk/challenge': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    amountCurrency: `Amount currency`,
    subTitle: `Sous-titre`,
    title: `Titre`,
    amountCents: `Montant (FCFA)`,
    target: `Cible (Km)`,
    walkClubId: `LeCLuB club`,
    walkPrizeId: `LeCLuB prix`,
    winnersCount: `Nombre de gagnants`,
    endDate: `Date de fin`,
    startDate: `Date de début`,
    prizeDesc: `Description du prix`,
    walkClub: `LeCLuB clubs`,
    walkPrize: `LeCLuB prix`,
    isStarted: `Est commencé`,
    isEnded: `Est terminé`,
    introduction: `Introduction`,
    cover: `Couverture`,
    detailImage: `Image détaillée`,
  },
  'walk/challengeParticipationRecord': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    amountCurrency: `Amount currency`,
    amountCents: `Montant (FCFA)`,
    miapayWalletHolderId: `Miapay wallet holder`,
    rewardState: `État de la récompense`,
    rewardStates: {
      init: 'Init',
      pending: 'En attente',
      requested: 'Demandé',
      sent: 'Envoyé',
      failed: 'Rang non atteint',
    },
    state: `Statut du défi`,
    states: {
      pending: 'Non payé',
      paid: 'En cours',
      completed: 'Complété',
      failed: 'Incomplet',
    },
    totalStep: `Étapes (après avoir rejoint)`,
    walkChallengeId: `LeCLuB défi`,
    paidAt: `Payé à`,
    totalKilometersDistance: `Distance (km)`,
    rank: `Rang`,
    miapayWalletHolder: `Miapay wallet holder`,
    walkChallenge: `LeCLuB défis`,
    phone: `Téléphoner`,
    fullName: `Nom complet`,
  },
  'link': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    type: `Type`,
    url: `Url`,
  },
  'operationRecord': {
    id: `ID`,
    createdAt: `Créé à`,
    updatedAt: `Mis à jour à`,
    content: `Contenu`,
    contentEn: `Content en`,
    adminUser: `utilisateur administrateur`,
    previousObject: `Previous object`,
    currentObject: `Current object`,
  },
  'setting': {
  },
}
